(function () {
  const CACHE_KEY = 'adawat_sale_pct_map_v13';
  const BUST_KEY = 'adawat_sale_bust';
  const CACHE_TTL_MS = 5 * 60 * 1000;
  let liveSitewide = 0;

  function sanePercent(value) {
    const n = Math.round(Number(value) || 0);
    if (n < 1 || n > 95) return 0;
    return n;
  }

  function percentFromTitle(text) {
    let max = 0;
    String(text || '').replace(/(\d+)\s*%/g, (_, digits) => {
      const n = Number(digits);
      if (n >= 1 && n <= 95) max = Math.max(max, n);
      return _;
    });
    return max;
  }

  function saleBustAt() {
    let local = 0;
    try {
      local = Number(localStorage.getItem(BUST_KEY) || 0);
    } catch (e) {}
    return Math.max(Number(window.__ADAWAT_SALE_CACHE_AT__ || 0), local);
  }

  function readCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY) || sessionStorage.getItem(CACHE_KEY);
      if (!raw) return { byVariant: {}, sitewide: 0 };
      const parsed = JSON.parse(raw);
      if (!parsed || Date.now() - Number(parsed.at || 0) > CACHE_TTL_MS) return { byVariant: {}, sitewide: 0 };
      if (Number(parsed.at || 0) < saleBustAt()) return { byVariant: {}, sitewide: 0 };
      const map = parsed.byVariant && typeof parsed.byVariant === 'object' ? parsed.byVariant : {};
      const clean = {};
      Object.entries(map).forEach(([id, percent]) => {
        const n = sanePercent(percent);
        if (n) clean[id] = n;
      });
      return { byVariant: clean, sitewide: sanePercent(parsed.sitewide) };
    } catch (e) {
      return { byVariant: {}, sitewide: 0 };
    }
  }

  function writeCache(byVariant) {
    if (!liveSitewide) return;
    const payload = JSON.stringify({ byVariant: byVariant || {}, sitewide: liveSitewide, at: Date.now() });
    try {
      localStorage.setItem(CACHE_KEY, payload);
    } catch (e) {}
    try {
      sessionStorage.setItem(CACHE_KEY, payload);
    } catch (e) {}
  }

  function sitewideSaleConfigOn() {
    const cfg = window.__ADAWAT_SITEWIDE_SALE__;
    if (cfg && typeof cfg === 'object') {
      if (cfg.enabled === false || cfg.enabled === 'false' || cfg.enabled === 0 || cfg.enabled === '0') {
        return false;
      }
      if (cfg.enabled === true || cfg.enabled === 'true' || cfg.enabled === 1 || cfg.enabled === '1') {
        return sanePercent(cfg.percent) > 0;
      }
      return sanePercent(cfg.percent) > 0;
    }
    return sanePercent(document.body?.dataset?.sitewidePercent) > 0;
  }

  function sitewideFromDom() {
    if (!sitewideSaleConfigOn()) return 0;
    const fromBody = sanePercent(document.body?.dataset?.sitewidePercent);
    if (fromBody) return fromBody;
    return liveSitewide;
  }

  function setLiveSitewide(percent) {
    if (!sitewideSaleConfigOn()) {
      liveSitewide = 0;
      return;
    }
    const fromBody = sanePercent(document.body?.dataset?.sitewidePercent);
    if (fromBody) {
      liveSitewide = fromBody;
      return;
    }
    const n = sanePercent(percent);
    if (!n) return;
    liveSitewide = n;
  }

  function clearSaleCache() {
    try {
      localStorage.removeItem(CACHE_KEY);
      localStorage.removeItem(BUST_KEY);
    } catch (e) {}
    try {
      sessionStorage.removeItem(CACHE_KEY);
    } catch (e) {}
  }

  function formatMoney(cents) {
    const value = Math.round(Number(cents) || 0);
    if (typeof window.adawatFormatMoney === 'function') return window.adawatFormatMoney(value);
    const amount = (value / 100).toFixed(2);
    const fmt = window.__ADAWAT_MONEY_FORMAT__ || window.Shopify?.money_format || '${{amount}}';
    return String(fmt).replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function percentFromLineItem(item) {
    if (!item) return 0;
    let fromTitle = 0;
    (item.discounts || []).forEach((disc) => {
      fromTitle = Math.max(fromTitle, percentFromTitle(disc.title || disc.code || ''));
    });
    (item.line_level_discount_allocations || []).forEach((row) => {
      const app = row?.discount_application || row;
      fromTitle = Math.max(fromTitle, percentFromTitle(app?.title || app?.code || ''));
    });
    fromTitle = Math.max(fromTitle, percentFromTitle(item.discount_title || ''));
    if (fromTitle) return sanePercent(fromTitle);
    const qty = Math.max(1, Number(item.quantity) || 1);
    const original = Number(item.original_line_price) || Number(item.original_price || 0) * qty;
    const final = Number(item.final_line_price) || Number(item.final_price || item.discounted_price || 0) * qty;
    if (original > final && original > 0) {
      return sanePercent(Math.round((1 - final / original) * 100 + 1e-8));
    }
    return 0;
  }

  function lineForVariant(payload, variantId) {
    const id = Number(variantId);
    const items = payload?.items || [];
    return (
      items.find((item) => Number(item.variant_id || item.id) === id) ||
      (Number(payload?.variant_id) === id ? payload : null)
    );
  }

  function saleLayers() {
    const raw = window.__ADAWAT_SALE_RULES__;
    if (!raw) return [];
    if (Array.isArray(raw.discounts) && raw.discounts.length) return raw.discounts;
    if (raw.percent) return [raw];
    return [];
  }

  function rulesPercent(node) {
    const host = node?.closest?.('[data-product-id], [data-adawat-collections]') || node;
    const productId = String(host?.getAttribute?.('data-product-id') || '').trim();
      const collections = String(host?.getAttribute?.('data-adawat-collections') || '')
        .split(/[|,]/)
        .map((part) => part.trim().toLowerCase())
        .filter(Boolean);
      let max = 0;
      saleLayers().forEach((layer) => {
        const pct = sanePercent(layer?.percent);
        if (!pct) return;
        const ids = (layer.product_ids || layer.productIds || []).map(String);
        const handles = (layer.collection_handles || layer.collectionHandles || [])
          .map((handle) => String(handle || '').toLowerCase().trim())
          .filter(Boolean);
        if (productId && ids.includes(productId)) max = Math.max(max, pct);
        else if (handles.some((handle) => collections.includes(handle))) max = Math.max(max, pct);
      });
    return max;
  }

  function sitewideAppliesTo(node) {
    if (!sitewideSaleConfigOn() || isExcluded(node)) return 0;
    const cfg = window.__ADAWAT_SITEWIDE_SALE__ || {};
    const allItems = cfg.all_items === true || cfg.allItems === true;
    const handles = [cfg.collection_handle, ...(cfg.collection_handles || [])]
      .map(asHandle)
      .filter(Boolean);
    if (!allItems && !handles.length) return 0;
    if (handles.length && !productCollections(node).some((handle) => handles.includes(handle))) return 0;
    return sitewideFromDom();
  }

  function bakedPercent(node) {
    let n = 0;
    let el = node;
    while (el && el !== document.body && el !== document.documentElement) {
      n = Math.max(n, sanePercent(el.getAttribute?.('data-adawat-sale-percent')));
      el = el.parentElement;
    }
    return n;
  }

  function excludeHandles() {
    const fromCfg = window.__ADAWAT_SITEWIDE_SALE__ || {};
    const fromRules = window.__ADAWAT_SALE_RULES__ || {};
    const listed = [
      'back-to-school',
      'no-discount',
      'no-discount-for-1-week-collection',
      ...(fromCfg.exclude_handles || []),
      ...(fromRules.exclude_handles || []),
      ...String(document.body?.dataset?.saleExclude || '')
        .split(',')
        .map((part) => part.trim()),
    ];
    return new Set(
      listed
        .map((handle) => String(handle || '').toLowerCase().trim())
        .filter(Boolean)
    );
  }

  function pathHasExcludedCollection(excluded) {
    const path = String(window.location.pathname || '').toLowerCase();
    const match = path.match(/\/collections\/([^/?#]+)/);
    if (!match) return false;
    try {
      return excluded.has(decodeURIComponent(match[1]));
    } catch (error) {
      return excluded.has(match[1]);
    }
  }

  function isExcluded(node) {
    if (!node) return false;
    if (node.getAttribute?.('data-adawat-sale-excluded') === 'true') return true;
    if (node.closest?.('[data-adawat-sale-excluded="true"]')) return true;
    const tags = excludeTags();
    if (tags.size && productTags(node).some((tag) => tags.has(tag))) return true;
    const excluded = excludeHandles();
    const sitewide = sitewideCollectionHandles();
    if (pathHasExcludedCollection(excluded)) {
      const path = String(window.location.pathname || '').toLowerCase();
      const match = path.match(/\/collections\/([^/?#]+)/);
      let handle = match?.[1] || '';
      try {
        handle = decodeURIComponent(handle);
      } catch (error) {}
      if (handle && !sitewide.has(handle)) return true;
    }
    const host = node.closest?.('[data-adawat-collections]') || node;
    const collections = String(host?.getAttribute?.('data-adawat-collections') || '')
      .split(/[|,]/)
      .map((part) => part.trim().toLowerCase())
      .filter(Boolean);
    return collections.some((handle) => excluded.has(handle) && !sitewide.has(handle));
  }

  function excludeTags() {
    const fromCfg = window.__ADAWAT_SITEWIDE_SALE__ || {};
    const fromRules = window.__ADAWAT_SALE_RULES__ || {};
    const listed = [
      'no-discount',
      'no discount',
      ...(fromCfg.exclude_tags || []),
      ...(fromRules.exclude_tags || []),
      ...String(document.body?.dataset?.saleExcludeTags || '').split(','),
    ];
    return new Set(
      listed
        .map((tag) => String(tag || '').toLowerCase().trim())
        .filter(Boolean)
    );
  }

  function productTags(node) {
    const host = node?.closest?.('[data-adawat-tags]') || node?.closest?.('[data-adawat-collections]') || node;
    return String(host?.getAttribute?.('data-adawat-tags') || '')
      .split(',')
      .map((tag) => tag.trim().toLowerCase())
      .filter(Boolean);
  }

  function variantIdFromNode(node) {
    if (!node) return 0;
    const attr = node.getAttribute?.('data-variant-id') || node.querySelector?.('[data-variant-id]')?.getAttribute('data-variant-id');
    const n = Number(attr || 0);
    if (n > 0) return n;
    const input = node.querySelector?.('[data-adawat-variant-id]');
    return Number(input?.value || 0);
  }

  function sitewideCollectionHandles() {
    const fromBody = String(document.body?.dataset?.sitewideCollections || '')
      .split(',')
      .map((part) => part.trim().toLowerCase())
      .filter(Boolean);
    const fromCfg = window.__ADAWAT_SITEWIDE_SALE__ || {};
    const listed = [
      ...fromBody,
      asHandle(fromCfg.collection_handle),
      ...((fromCfg.collection_handles || []).map(asHandle)),
      'all-products-excluding-collections',
      'all-products-excluding-collection',
      'all-products-excluding',
      'all-products-excluding-collections-copy',
    ];
    return new Set(listed.filter(Boolean));
  }

  function asHandle(value) {
    return String(value || '').toLowerCase().trim();
  }

  function productCollections(node) {
    const host = node?.closest?.('[data-adawat-collections]') || node;
    return String(host?.getAttribute?.('data-adawat-collections') || '')
      .split(/[|,]/)
      .map((part) => part.trim().toLowerCase())
      .filter(Boolean);
  }

  function inSitewideCollection(node) {
    const handles = sitewideCollectionHandles();
    return productCollections(node).some((handle) => handles.has(handle));
  }

  function isNoDiscount(node) {
    const tags = productTags(node);
    if (tags.includes('no-discount') || tags.includes('no discount')) return true;
    return productCollections(node).some((handle) => handle.includes('no-discount'));
  }

  function saleBasis(node) {
    const host = node?.closest?.('[data-adawat-sale-basis]') || node;
    return host?.getAttribute?.('data-adawat-sale-basis') || '';
  }

  function percentForNode(node, byVariant) {
    const host =
      node.closest?.(
        '[data-adawat-pdp], .adawat-product-card, .adawat-mega__product, .adawat-deal-card, .adawat-featured-look'
      ) || node;
    if (isNoDiscount(host)) return 0;
    /* Highest wins: a 50% product/collection discount beats the 15% sitewide sale.
       A cached sitewide % must not cover a higher saved discount. */
    const rules = rulesPercent(host);
    const baked = bakedPercent(host);
    const id = variantIdFromNode(host) || variantIdFromNode(node);
    let learned = sanePercent(id ? byVariant?.[id] : 0);
    const excluded = isExcluded(host);
    const globalSitewide = sitewideFromDom();
    const sitewide = sitewideAppliesTo(host);
    if (!sitewide && learned === globalSitewide) learned = 0;
    const bakedUse = !sitewide && baked === globalSitewide ? 0 : baked;
    // basis=compare only blocks price remultiply — badge % still follows Admin discount.
    if (excluded && !rules && !bakedUse) return learned;
    return Math.max(rules, bakedUse, sitewide, learned);
  }

  function parseMoneyNumber(raw) {
    const text = String(raw || '')
      .trim()
      .replace(/[^\d.,-]/g, '');
    if (!text) return NaN;
    // Prefer the last separator as decimal when both exist (1.234,56 or 1,234.56)
    const lastComma = text.lastIndexOf(',');
    const lastDot = text.lastIndexOf('.');
    let normalized = text;
    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) normalized = text.replace(/\./g, '').replace(',', '.');
      else normalized = text.replace(/,/g, '');
    } else if (lastComma > -1) {
      normalized = text.replace(',', '.');
    }
    const n = Number(normalized);
    return Number.isFinite(n) ? n : NaN;
  }

  function listCents(el) {
    const host = el.closest?.('[data-price-cents], [data-price-dollars]') || el;
    const centsRaw = host?.getAttribute?.('data-price-cents');
    const dollarsRaw = host?.getAttribute?.('data-price-dollars');
    const cents = parseMoneyNumber(centsRaw);
    const dollars = parseMoneyNumber(dollarsRaw);

    // products.json bug: dollars written into data-price-cents ("2" for $2.00)
    if (Number.isFinite(cents) && cents > 0 && Number.isFinite(dollars) && dollars > 0) {
      const fromDollars = Math.round(dollars * 100);
      if (Math.abs(cents - dollars) < 0.001 && cents < 1000) return fromDollars;
      if (fromDollars >= 100 && cents * 100 === fromDollars) return fromDollars;
      if (fromDollars > cents * 10) return fromDollars;
    }

    if (Number.isFinite(cents) && cents > 0) return Math.round(cents);

    if (Number.isFinite(dollars) && dollars > 0) {
      if (Number.isInteger(dollars) && dollars >= 1000) return Math.round(dollars);
      return Math.round(dollars * 100);
    }
    return 0;
  }

  function applyPriceBlock(priceEl, percent) {
    if (!priceEl || isNoDiscount(priceEl)) return;
    const current = priceEl.querySelector('.adawat-price__current, .adawat-sale-price__current');
    if (!current) return;
    const useSaleHook = priceEl.classList.contains('adawat-sale-price');
    const pctClass = useSaleHook ? 'adawat-sale-price__badge' : 'adawat-price__badge';
    // Compare-at products: keep Shopify prices, only sync the Admin discount badge.
    if (saleBasis(priceEl) === 'compare') {
      if (!percent) return;
      priceEl.classList.add(useSaleHook ? 'is-on-sale' : 'adawat-price--on-sale');
      let badge = priceEl.querySelector('.adawat-price__badge, .adawat-sale-price__badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = pctClass;
        priceEl.appendChild(badge);
      }
      badge.textContent = `-${percent}%`;
      return;
    }
    const originalCents = listCents(priceEl);
    if (!originalCents) return;
    if (!percent) {
      current.textContent = formatMoney(originalCents);
      priceEl.classList.remove('is-on-sale', 'adawat-price--on-sale');
      priceEl.querySelectorAll('.adawat-price__compare, .adawat-sale-price__compare, .adawat-price__badge, .adawat-sale-price__badge').forEach((el) => el.remove());
      if (!priceEl.contains(current)) priceEl.replaceChildren(current);
      return;
    }
    const saleCents = Math.round((originalCents * (100 - percent)) / 100);
    const compare = document.createElement('s');
    compare.className = useSaleHook ? 'adawat-sale-price__compare' : 'adawat-price__compare';
    compare.textContent = formatMoney(originalCents);
    current.textContent = formatMoney(saleCents);
    const badge = document.createElement('span');
    badge.className = pctClass;
    badge.textContent = `-${percent}%`;
    priceEl.classList.add(useSaleHook ? 'is-on-sale' : 'adawat-price--on-sale');
    priceEl.replaceChildren(compare, current, badge);
  }

  function applyOverlayBadge(container, percent) {
    if (!container || isNoDiscount(container)) return;
    if (!percent && saleBasis(container) === 'compare') return;
    if (container.querySelector('.adawat-badge--soldout')) return;
    const existing = container.querySelector('.adawat-badge--sale');
    if (!percent) {
      // Never wipe Liquid/server discount badges — they must load first from Save discounts.
      if (existing?.dataset.adawatSaleBadgeJs === '1') existing.remove();
      return;
    }
    if (existing) {
      existing.hidden = false;
      existing.removeAttribute('hidden');
      existing.textContent = `-${percent}%`;
      if (existing !== container.firstElementChild) {
        container.insertBefore(existing, container.firstChild);
      }
      return;
    }
    const span = document.createElement('span');
    span.className = 'adawat-badge adawat-badge--sale';
    span.dataset.adawatSaleBadgeJs = '1';
    span.textContent = `-${percent}%`;
    container.insertBefore(span, container.firstChild);
  }

  function applyPdp(root, percent) {
    if (!root || isNoDiscount(root)) return;
    const original = listCents(root) || Number(window.__ADAWAT_PDP_LIST_CENTS__ || 0);
    const priceEl = root.querySelector('[data-adawat-price]');
    const compareEl = root.querySelector('[data-adawat-compare-price]');
    const saleBadge = root.querySelector('[data-adawat-sale-badge]');
    const priceBadge = root.querySelector('[data-adawat-price-badge]');
    const compareBasis = saleBasis(root) === 'compare';
    if (!percent) {
      if (!compareBasis) {
        if (original && priceEl) priceEl.textContent = formatMoney(original);
        if (compareEl) {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
        root.querySelector('[data-adawat-price-wrap]')?.classList.remove('adawat-pdp__price--on-sale');
      }
      // Keep Liquid discount badges; only clear empty JS placeholders.
      if (saleBadge && !saleBadge.textContent.trim()) {
        saleBadge.hidden = true;
        saleBadge.textContent = '';
      }
      if (priceBadge && !priceBadge.textContent.trim()) {
        priceBadge.hidden = true;
        priceBadge.textContent = '';
      }
      return;
    }
    if (percent > Number(root.dataset.adawatSalePercent || 0)) {
      root.dataset.adawatSalePercent = String(percent);
    }
    if (saleBadge) {
      saleBadge.hidden = false;
      saleBadge.textContent = `-${percent}%`;
    }
    if (priceBadge) {
      priceBadge.hidden = false;
      priceBadge.textContent = `-${percent}%`;
    }
    root.querySelector('[data-adawat-price-wrap]')?.classList.add('adawat-pdp__price--on-sale');
    // Compare-at: keep Shopify prices; only sync badges above.
    if (compareBasis || root.dataset.adawatPdpInit === 'true') return;
    if (original && priceEl) {
      priceEl.textContent = formatMoney(Math.round((original * (100 - percent)) / 100));
    }
    if (compareEl && original) {
      compareEl.textContent = formatMoney(original);
      compareEl.hidden = false;
    }
  }

  function applyMegaProduct(card, percent) {
    if (!card) return;
    const media = card.querySelector('.adawat-mega__product-media');
    applyOverlayBadge(media, percent);
    const priceWrap = card.querySelector('.adawat-mega__product-price');
    const current = priceWrap?.querySelector('.adawat-mega__product-current');
    if (!priceWrap || !current) return;
    if (saleBasis(card) === 'compare') {
      if (!percent) return;
      let badge = priceWrap.querySelector('.adawat-price__badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'adawat-price__badge';
        priceWrap.appendChild(badge);
      }
      badge.textContent = `-${percent}%`;
      return;
    }
    const originalCents = listCents(card);
    if (!originalCents) return;
    if (!percent) return;
    const saleCents = Math.round((originalCents * (100 - percent)) / 100);
    const compare = document.createElement('span');
    compare.className = 'adawat-mega__product-compare';
    compare.textContent = formatMoney(originalCents);
    current.textContent = formatMoney(saleCents);
    const badge = document.createElement('span');
    badge.className = 'adawat-price__badge';
    badge.textContent = `-${percent}%`;
    priceWrap.replaceChildren(compare, current, badge);
  }

  const cached = readCache();
  let byVariantState = cached.byVariant;
  if (!sitewideSaleConfigOn()) {
    liveSitewide = 0;
    byVariantState = {};
    clearSaleCache();
  } else {
    liveSitewide =
      sanePercent(document.body?.dataset?.sitewidePercent) ||
      sanePercent(window.__ADAWAT_SITEWIDE_SALE__?.percent) ||
      sanePercent(cached.sitewide);
  }

  function applySaleMap(byVariant) {
    byVariantState = byVariant || {};
    window.__ADAWAT_SALE_BY_VARIANT__ = byVariantState;
    window.__ADAWAT_SALE_PERCENT__ = sitewideFromDom();
    writeCache(byVariantState);

    // Badges first (visible priority), then prices.
    document.querySelectorAll('.adawat-product-card').forEach((card) => {
      const percent = percentForNode(card, byVariantState);
      applyOverlayBadge(card.querySelector('.adawat-product-card__badges, [data-adawat-sale-badges]'), percent);
      applyPriceBlock(card.querySelector('.adawat-price, .adawat-sale-price'), percent);
    });
    document.querySelectorAll('[data-adawat-sale-badges]').forEach((el) => {
      if (el.closest('.adawat-product-card, .adawat-mega__product')) return;
      applyOverlayBadge(el, percentForNode(el, byVariantState));
    });
    document.querySelectorAll('[data-adawat-pdp]').forEach((root) => {
      applyPdp(root, percentForNode(root, byVariantState));
    });
    document.querySelectorAll('.adawat-mega__product').forEach((card) => {
      applyMegaProduct(card, percentForNode(card, byVariantState));
    });
    document.querySelectorAll('.adawat-sale-price').forEach((priceEl) => {
      if (priceEl.closest('.adawat-product-card')) return;
      applyPriceBlock(priceEl, percentForNode(priceEl, byVariantState));
    });

    window.dispatchEvent(
      new CustomEvent('adawat:sitewide-sale', {
        detail: { percent: sitewideFromDom(), byVariant: byVariantState },
      })
    );
  }

  const PROBE_PROP = '_adawat_sale_probe';

  function isProbeItem(item) {
    const props = item?.properties;
    return Boolean(props && props[PROBE_PROP]);
  }

  function realCartItems(items) {
    return (items || []).filter((item) => !isProbeItem(item) && Number(item.quantity) > 0);
  }

  function ingestCartItems(items) {
    (items || []).forEach((item) => {
      const id = Number(item.variant_id || item.id || 0);
      const percent = percentFromLineItem(item);
      if (id > 0 && percent > 0) {
        const current = sanePercent(byVariantState[String(id)]);
        byVariantState[String(id)] = Math.max(current, percent);
      }
    });
  }

  function shopRoot() {
    return (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  }

  function visibleVariantIds() {
    const ids = [];
    const seen = new Set();
    const push = (raw) => {
      const id = Number(raw || 0);
      if (!id || seen.has(id)) return;
      seen.add(id);
      ids.push(id);
    };
    document.querySelectorAll('[data-adawat-pdp][data-variant-id], [data-adawat-pdp] [data-variant-id]').forEach((el) => {
      push(el.getAttribute('data-variant-id') || el.value);
    });
    document.querySelectorAll('.adawat-product-card[data-variant-id]').forEach((el) => {
      push(el.getAttribute('data-variant-id'));
    });
    // Prefer variants whose baked badge equals sitewide (likely wrong vs a higher Admin discount).
    const sitewide = sitewideFromDom();
    if (sitewide) {
      const suspect = [];
      document.querySelectorAll('.adawat-product-card[data-variant-id]').forEach((el) => {
        const baked = sanePercent(el.getAttribute('data-adawat-sale-percent'));
        if (!baked || baked === sitewide) suspect.push(Number(el.getAttribute('data-variant-id')));
      });
      suspect.filter(Boolean).forEach((id) => push(id));
    }
    return ids.slice(0, 16);
  }

  let probeBusy = false;
  let probeAborted = false;

  window.AdawatAbortSaleProbe = function () {
    probeAborted = true;
  };

  async function removeProbeLines() {
    const root = shopRoot();
    const cart = await fetch(`${root}cart.js`, { credentials: 'same-origin' }).then((res) =>
      res.ok ? res.json() : null
    );
    if (!cart?.items?.length) return cart;
    const updates = {};
    let hasProbe = false;
    cart.items.forEach((item) => {
      if (!isProbeItem(item)) return;
      hasProbe = true;
      updates[item.key] = 0;
    });
    if (!hasProbe) return cart;
    return fetch(`${root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    }).then((res) => (res.ok ? res.json() : cart));
  }

  /**
   * Dummy cart/add.js probes raced real add-to-cart. Do not probe.
   * Only strip leftover probe lines from older theme versions.
   */
  async function cleanupLeftoverProbeLines() {
    if (probeBusy) return;
    probeBusy = true;
    try {
      await removeProbeLines();
    } catch (e) {
      /* ignore */
    } finally {
      probeBusy = false;
      window.__ADAWAT_SALE_PROBE__ = false;
    }
  }

  window.AdawatClearSaleCache = function () {
    ['adawat_sale_pct_map_v5', 'adawat_sale_pct_map_v6', 'adawat_sale_pct_map_v7', 'adawat_sale_pct_map_v8', 'adawat_sale_pct_map_v9', 'adawat_sale_pct_map_v10', 'adawat_sale_pct_map_v11', 'adawat_sale_pct_map_v12', 'adawat_sale_sitewide_v1', 'adawat_sale_sitewide_v2', 'adawat_sale_bust', 'adawat_sitewide_sync_at', 'adawat_sitewide_sync_sig'].forEach((key) => {
      try {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      } catch (e) {}
    });
    window.location.reload();
  };
  window.AdawatReapplySale = function () {
    applySaleMap(byVariantState);
  };
  window.AdawatRefreshSale = function () {
    applySaleMap(byVariantState);
  };
  window.AdawatIngestSaleItems = function (items) {
    ingestCartItems(items);
    applySaleMap(byVariantState);
  };

  document.addEventListener('cart:update', (event) => {
    if (window.__ADAWAT_SALE_PROBE__) return;
    if (event?.detail?.source === 'adawat-sale-probe') return;
    const items = event?.detail?.items;
    if (items?.length) {
      ingestCartItems(items);
      applySaleMap(byVariantState);
    }
  });

  try {
    ['adawat_sale_pct_map_v3', 'adawat_sale_pct_map_v4', 'adawat_sale_pct_map_v5', 'adawat_sale_pct_map_v6', 'adawat_sale_pct_map_v7', 'adawat_sale_pct_map_v8', 'adawat_sale_pct_map_v9', 'adawat_sale_pct_map_v10', 'adawat_sale_pct_map_v11', 'adawat_sale_sitewide_v1', 'adawat_sale_sitewide_v2'].forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
  } catch (e) {}

  function init() {
    applySaleMap(byVariantState);
    try {
      const root = shopRoot();
      fetch(`${root}cart.js`, { credentials: 'same-origin' })
        .then((res) => (res.ok ? res.json() : null))
        .then((cart) => {
          if (cart?.items?.length) {
            ingestCartItems(realCartItems(cart.items));
            applySaleMap(byVariantState);
            if ((cart.items || []).some(isProbeItem)) cleanupLeftoverProbeLines();
          }
        })
        .catch(() => {})
        .finally(() => {
          /* Do not add dummy cart lines to read sale %. That lagged add-to-cart. */
        });
    } catch (e) {
      /* ignore cart read failures */
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  const megaRoot = document.querySelector('[data-adawat-mega]');
  if (megaRoot) {
    let timer = 0;
    const sync = () => {
      if (!megaRoot.classList.contains('is-open')) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => window.AdawatReapplySale?.(), 80);
    };
    new MutationObserver(sync).observe(megaRoot, { attributes: true, attributeFilter: ['class'] });
    megaRoot.querySelectorAll('[data-mega-cat]').forEach((cat) => {
      cat.addEventListener('mouseenter', sync);
      cat.addEventListener('click', sync);
    });
  }
})();
